export const defaultDatePickerDateFormat = [
    { text: '${date|d|ddd}', className: 'v-date-picker-date__day-of-week' },
    { text: '${date|d|D}', className: 'v-date-picker-date__day-of-month' },
    { text: '${date|d|MMM}', className: 'v-date-picker-date__month' }
];
export const defaultDatePickerTodayDateFormat = 'Today';
export const defaultDatePickerCarouselConfig = {
    showDots: false,
    refreshOnUpdate: true,
    settings: {
        slidesToScroll: 'auto',
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 7
                }
            }
        ]
    },
    touchSettings: {
        slidesToScroll: 'auto',
        slidesToShow: 2.5,
        responsive: [
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 3.5
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 5.5
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 7.5
                }
            }
        ]
    }
};
